/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Force Availability filter ON when any other filter is active.
  // Pairs with redirect logic in layout/theme.liquid <head>.
  var FORCE_NAME = 'filter.v.availability';
  var FORCE_VALUE = '1';
  var FORCE_MARKER = 'data-force-availability';

  function isOtherFilterParam(key) {
    return key && key !== FORCE_NAME && key.indexOf('filter.') === 0;
  }

  function syncForm(form) {
    if (!form) return;
    var formData = new FormData(form);
    var hasOther = false;
    var entries = formData.entries();
    var entry = entries.next();
    while (!entry.done) {
      var pair = entry.value;
      if (pair[1] !== '' && isOtherFilterParam(pair[0])) {
        hasOther = true;
        break;
      }
      entry = entries.next();
    }
    var existing = form.querySelector('input[' + FORCE_MARKER + ']');
    if (hasOther && !existing) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = FORCE_NAME;
      input.value = FORCE_VALUE;
      input.setAttribute(FORCE_MARKER, '');
      form.appendChild(input);
    } else if (!hasOther && existing) {
      existing.parentNode.removeChild(existing);
    }
  }

  function initAvailabilitySync() {
    var forms = document.querySelectorAll('[data-collection-filters-form]');
    for (var i = 0; i < forms.length; i++) syncForm(forms[i]);

    function handler(e) {
      var form = e.target.closest && e.target.closest('[data-collection-filters-form]');
      if (form) syncForm(form);
    }
    document.addEventListener('change', handler, true);
    document.addEventListener('input', handler, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAvailabilitySync);
  } else {
    initAvailabilitySync();
  }

  document.addEventListener('scroll', function () {
      const element = document.querySelector('.collection__filters--visible'); // Replace with your class name
      if (element) {
          element.classList.remove('collection__filters--visible');
      }
  });





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

$(document).ready(function () {
  if ($(".model-stats").length > 0) {
    console.log("HAS MODEL STATS");
    $(".model-stats").show();
    $(".product__accordion.models-stats").show();
    $(".product__accordion__inner.rte.models-stats").append($(".model-stats"));
    document.querySelector('.product__accordion__inner.rte.models-stats>p').style.display = 'none'; {
}
  }
});

/*
document.addEventListener('DOMContentLoaded', function () {
  // Ambil semua elemen .model-stats yang tersembunyi
  const modelStats = document.querySelectorAll('.model-stats');
  const accordionContent = document.querySelector(
    '.product__accordion__inner.rte.models-stats'
  );

  // Bersihkan konten default dari accordion
  accordionContent.innerHTML = '';

  // Pindahkan setiap model stat ke dalam accordion
  modelStats.forEach(stat => {
    accordionContent.appendChild(stat.cloneNode(true));
  });

  // Pastikan model stats dalam accordion terlihat
  document.querySelector('.models-stats').style.display = 'block';
  document.querySelector('.product__accordion.models-stats').style.display = 'block';
});*/
